import { render, staticRenderFns } from "./acvitateLogin.vue?vue&type=template&id=bd3b0f28&scoped=true&"
import script from "./acvitateLogin.vue?vue&type=script&lang=js&"
export * from "./acvitateLogin.vue?vue&type=script&lang=js&"
import style0 from "./acvitateLogin.vue?vue&type=style&index=0&id=bd3b0f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3b0f28",
  null
  
)

export default component.exports